export const fileMapper = ({ id, caption, public_name: publicName = '', public_path: publicPath }) => {
  return ({
    id,
    publicName,
    publicPath,
    caption
  });
};
